import { Tracker } from '@schibsted/pulse-sdk';

import { getActorPromise } from '../../../../src/core/mandatory-integrations/pulse/utils/index.js';
import { getDeployInfo } from './deploy-info.js';

let pulseTracker: Promise<Tracker> | undefined;

export const getPulseTracker = (
  providerId: string,
  productTag?: string,
): Promise<Tracker> => {
  if (pulseTracker) {
    return pulseTracker;
  }

  const { deployStage, deployTag } = getDeployInfo();

  const tracker = new Tracker(
    providerId,
    {
      deployStage,
      nativeJwe: window.hermesJwe,
      altEventHandler: window.pulseEventHandler,
      autoCreateConsents: true,
      requireAdvertisingOptIn: true,
      adChoicesEnabled: true,
      deployStageTpaas: 'pre',
    },
    {
      actor: getActorPromise(),
      provider: {
        id: providerId,
        productTag,
        product: 'fastenposten',
        productType: 'ResponsiveWeb',
      },
    },
  );

  if (deployStage === 'dev') {
    tracker.update({ deployTag, deployStage });
  }

  pulseTracker = Promise.resolve(tracker);

  return pulseTracker;
};
